/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, {useState, useEffect} from "react";
import {useLocation} from "react-router";
import {NavLink}  from "react-router-dom";
import SVG from "react-inlinesvg";
import {toAbsoluteUrl, checkIsActive} from "../../../../_helpers";
import { useSelector, useDispatch } from "react-redux";
import { fetchUserPermissions } from "../../../../../app/pages/Buyer/UsersCrud"
import {ordersCountActions} from '../../../../../redux/reducers/ordersCount';

export function SupplierMenu({ layoutProps}) {
    const [roles, setRoles] = useState([])
    const [permissions, setPermissions] = useState([])

    const location = useLocation();
    const {storedUser, accessToken} = useSelector(
        ({auth}) => ({
          storedUser: auth.user != null ? auth.user : null,
          accessToken: auth.authToken,
        })
    )

    const { count } = useSelector(({ ordersCount }) => ({
        count: ordersCount,
    }));

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(ordersCountActions.getSupplierOrdersCount(accessToken, storedUser.id))
        setRoles(storedUser.roles)
    
        fetchUserPermissions(accessToken).then(response => {
    
            console.log("Roles: ", storedUser.roles)
            console.log("Permissions response: ", response)
            setPermissions(response.data)
    
        }).catch(error => console.log(error))
      }, [  ])

    const getMenuItemActive = (url, hasSubmenu = false) => {
        return checkIsActive(location, url)
            ? ` ${!hasSubmenu && "menu-item-active"} menu-item-open `
            : "";
    };

    return (
        <>

                <ul className={`menu-nav ${layoutProps.ulClasses}`}>
                    {/*begin::1 Level*/}
                    {/* <li
                        className={`menu-item ${getMenuItemActive("/dashboard", false)}`}
                        aria-haspopup="true"
                    >
                        <NavLink className="menu-link" to="/dashboard">
                            <span className="svg-icon menu-icon">
                                <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}/>
                            </span>
                            <span className="menu-text">Dashboard</span>
                        </NavLink>
                    </li> */}
                    {/*end::1 Level*/}

                    {/*begin::1 Level*/}
                    {/* <li
                        className={`menu-item ${getMenuItemActive("/applications", false)}`}
                        aria-haspopup="true"
                    >
                        <NavLink className="menu-link" to="/applications">
          <span className="svg-icon menu-icon">
          <SVG src={toAbsoluteUrl("/media/svg/icons/Layout/Layout-4-blocks.svg")}/>
          </span>
                            <span className="menu-text">Applications</span>
                        </NavLink>
                    </li> */}
                    {/*end::1 Level*/}

                    {/*begin::1 Level*/}
                    {/* <li
                        className={`menu-item ${getMenuItemActive("/orders", false)}`}
                        aria-haspopup="true"
                    >
                        <NavLink className="menu-link" to="/orders">
          <span className="svg-icon menu-icon">
          <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Cart2.svg")}/>
          </span>
                            <span className="menu-text">Orders</span>
                        </NavLink>
                    </li> */}
                    {/*end::1 Level*/}
                    { permissions.includes("route_management") ?
                            <li
                                className={`menu-item ${getMenuItemActive("/routes", false)}`}
                                aria-haspopup="true"
                            >
                                <NavLink className="menu-link" to="/routes">
                                    <span className="svg-icon menu-icon">
                                    <SVG src={toAbsoluteUrl("/media/svg/icons/Map/Marker2.svg")} />
                                    </span>
                                    <span className="menu-text">Route Management</span>
                                </NavLink>
                            </li>
                        :
                            null
                    }
                    
                    
                    {
                        permissions.includes("supplier_orders") ?
                            <li
                                className={`menu-item menu-item-submenu ${getMenuItemActive(
                                    "/orders",
                                    true
                                )}`}
                                aria-haspopup="true"
                                data-menu-toggle="hover"
                            >
                                <NavLink className="menu-link" to={"/orders"}>
                                    <span className="svg-icon menu-icon">
                                        <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Cart2.svg")} />
                                    </span>
                                    <span className="menu-text">Orders</span>
                                    <i className="menu-arrow" />
                                </NavLink>
                                <div className="menu-submenu ">
                                    <i className="menu-arrow" />
                                    <ul className="menu-subnav">
                                        <li
                                            className={`menu-item  ${getMenuItemActive(
                                            "/orders/pending_approval"
                                            )}`}
                                            aria-haspopup="true"
                                        >
                                            <NavLink className="menu-link" to="/orders/pending_approval">
                                            <i className="menu-bullet menu-bullet-dot">
                                                <span />
                                            </i>
                                            <span className="menu-text">{`Pending Approval`}</span>
                                            <span className="menu-label">
                                                <span className="label label-lg label-light-primary label-inline">
                                                    {count.pendingApprovalCount}
                                                </span>
                                            </span>
                                            </NavLink>
                                        </li>
                                        <li
                                            className={`menu-item  ${getMenuItemActive(
                                            "/orders/approved"
                                            )}`}
                                            aria-haspopup="true"
                                        >
                                            <NavLink className="menu-link" to="/orders/approved">
                                            <i className="menu-bullet menu-bullet-dot">
                                                <span />
                                            </i>
                                            <span className="menu-text">{`Approved`}</span>
                                            <span className="menu-label">
                                                <span className="label label-lg label-light-primary label-inline">
                                                    {count.approvedCount}
                                                </span>
                                            </span>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        :
                            null
                    }
                    
                    {/*begin::1 Level*/}
                    {/* <li
                        className={`menu-item ${getMenuItemActive("/myclients", false)}`}
                        aria-haspopup="true"
                    >
                        <NavLink className="menu-link" to="/myclients">
          <span className="svg-icon menu-icon">
          <SVG src={toAbsoluteUrl("/media/svg/icons/General/User.svg")}/>
          </span>
                            <span className="menu-text">My Clients</span>
                        </NavLink>
                    </li> */}
                    {/*end::1 Level*/}

                    {/*begin::1 Level*/}
                        {/* <li
                            className={`menu-item ${getMenuItemActive("/analytics", false)}`}
                            aria-haspopup="true"
                        >
                            <NavLink className="menu-link" to="/analytics">
                                <span className="svg-icon menu-icon">
                                    <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Chart-line1.svg")}/>
                                </span>
                                <span className="menu-text">Analytics</span>
                            </NavLink>
                        </li> */}

                    <li
                        className={`menu-item ${getMenuItemActive("/supplierAdmin/", false)}`}
                        aria-haspopup="true"
                    >
                        <NavLink className="menu-link" to={ permissions.includes("route_management") ? 
                                                                "/supplierAdmin/" + storedUser.supplierId 
                                                            : 
                                                                "/supplierAdmin/suppliers"}>
                            <span className="svg-icon menu-icon">
                                <SVG src={toAbsoluteUrl("/media/svg/icons/Map/Marker2.svg")} />
                            </span>
                            <span className="menu-text">Admin</span>
                            <i className="menu-arrow" />
                        </NavLink>
                        <div className="menu-submenu ">
                            <i className="menu-arrow" />
                            <ul className="menu-subnav">
                                { permissions.includes("route_management") ?
                                    <li
                                        className={`menu-item  ${getMenuItemActive(
                                        "/supplierAdmin/" + storedUser.supplierId
                                        )}`}
                                        aria-haspopup="true"
                                    >
                                        <NavLink className="menu-link" to={"/supplierAdmin/" + storedUser.supplierId}>
                                        <i className="menu-bullet menu-bullet-dot">
                                            <span />
                                        </i>
                                        <span className="menu-text">{`Routes`}</span>
                                        </NavLink>
                                    </li>
                                    
                                :
                                    null
                                }
                                { permissions.includes("supplier_config") ?
                                    <li
                                        className={`menu-item  ${getMenuItemActive(
                                        "/supplierAdmin/suppliers"
                                        )}`}
                                        aria-haspopup="true"
                                    >
                                        <NavLink className="menu-link" to="/supplierAdmin/suppliers">
                                        <i className="menu-bullet menu-bullet-dot">
                                            <span />
                                        </i>
                                        <span className="menu-text">{`Suppliers`}</span>
                                        </NavLink>
                                    </li>
                                    
                                :
                                    null
                                }
                                { permissions.includes("item_config") ?
                                    <li
                                        className={`menu-item  ${getMenuItemActive(
                                        "/supplierAdmin/products"
                                        )}`}
                                        aria-haspopup="true"
                                    >
                                        <NavLink className="menu-link" to="/supplierAdmin/products">
                                        <i className="menu-bullet menu-bullet-dot">
                                            <span />
                                        </i>
                                        <span className="menu-text">{`Products`}</span>
                                        </NavLink>
                                    </li>
                                    
                                :
                                    null
                                }
                                { permissions.includes("item_config") ?
                                    <li
                                        className={`menu-item  ${getMenuItemActive(
                                        "/supplierAdmin/productPrices"
                                        )}`}
                                        aria-haspopup="true"
                                    >
                                        <NavLink className="menu-link" to="/supplierAdmin/productPrices">
                                        <i className="menu-bullet menu-bullet-dot">
                                            <span />
                                        </i>
                                        <span className="menu-text">{`Product Prices`}</span>
                                        </NavLink>
                                    </li>
                                    
                                :
                                    null
                                }
                                { permissions.includes("user_config") ?
                                    <li
                                        className={`menu-item  ${getMenuItemActive(
                                        "/supplierAdmin/users"
                                        )}`}
                                        aria-haspopup="true"
                                    >
                                        <NavLink className="menu-link" to="/supplierAdmin/users">
                                        <i className="menu-bullet menu-bullet-dot">
                                            <span />
                                        </i>
                                        <span className="menu-text">{`Users`}</span>
                                        </NavLink>
                                    </li>
                                    
                                :
                                    null
                                }
                            </ul>
                        </div>
                    </li>

                    {roles.includes("supplier_central_super_admin") ?
                        <li
                            className="menu-item"
                            aria-haspopup="true"
                        >
                            <a className="menu-link" href={process.env.REACT_APP_ADMIN_URL + "/tenant/menu"} target="_blank" rel="noopener noreferrer">
                                <span className="svg-icon menu-icon">
                                    <SVG src={toAbsoluteUrl("/media/svg/icons/Home/Box.svg")}/>
                                </span>
                                <span className="menu-text">Central Admin</span>
                            </a>
                        </li>
                    :
                        null
                    }
                    {/*end::1 Level*/}

                    {/*begin::1 Level*/}
                    {/* <li
                        className={`menu-item ${getMenuItemActive("/accountsettings", false)}`}
                        aria-haspopup="true"
                    >
                        <NavLink className="menu-link" to="/accountsettings">
          <span className="svg-icon menu-icon">
          <SVG src={toAbsoluteUrl("/media/svg/icons/Code/Settings4.svg")}/>
          </span>
                            <span className="menu-text">Account Settings</span>
                        </NavLink>
                    </li> */}

                    {/*end::1 Level*/}

                    {/*begin::1 Level*/}
                    {/* <li
              className={`menu-item ${getMenuItemActive("/builder", false)}`}
              aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/builder">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Home/Library.svg")}/>
            </span>
              <span className="menu-text">Layout Builder</span>
            </NavLink>
          </li> */}
                    {/*end::1 Level*/}

                    {/* Components */}
                    {/* begin::section */}
                    {/* <li className="menu-section ">
            <h4 className="menu-text">Components</h4>
            <i className="menu-icon flaticon-more-v2"></i>
          </li> */}
                    {/* end:: section */}

                    {/* Material-UI */}
                    {/*begin::1 Level*/}

                    {/*end::1 Level*/}
                </ul>
            </>
    );
}
